<template>
  <vx-card title="Подача показаний">
    <div slot="actions">
      <div class="mb-2 mr-2 filterType">
        <elsa-v-select
          :options="apartmentTypes"
          v-model="selectedApartmentsType"
          label="name"
          :reduce="item => item.id"
          :clearable="false"
          htmlLabel="Тип помещения"
        />
      </div>
    </div>

    <template v-if="Object.values(config).length">
      <div class="settings-table-wrapper">
        <table class="settings-table mb-4">
          <thead>
          <tr>
            <th>Тип прибора учета</th>
            <th>Показывать в ЛК</th>
            <th>Подача из ЛК</th>
            <th>С какого числа</th>
            <th>По какое число</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(deviceSetting, deviceId) in config"
            :key="`setting-${deviceId}`"
            :set="deviceType = getDeviceType(deviceId)"
          >
            <td>
              <div class="flex items-center">
                <feather-icon
                  v-if="deviceType.icon"
                  class="device-icon mr-2"
                  :svg-classes="[`text-${deviceType.icon_color}`]"
                  :icon="deviceType.icon"
                />
                {{ deviceType.name }}
              </div>
            </td>
            <td>
              <vs-switch v-model="deviceSetting.display" :disabled="!$can('rp.devices', 'write')" />
            </td>
            <td>
              <vs-switch v-model="deviceSetting.enabled" :disabled="!$can('rp.devices', 'write')" />
            </td>
            <td>
              <vs-input
                type="number" style="width: 120px" v-model.number="deviceSetting.from"
                :disabled="!$can('rp.devices', 'write')" :min="1" :max="31"
              />
            </td>
            <td>
              <vs-input
                type="number" style="width: 120px" v-model.number="deviceSetting.to"
                :disabled="!$can('rp.devices', 'write')" :min="1" :max="31"
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full flex justify-center">
          <vs-button color="success" @click="saveSettings" v-if="$can('rp.devices', 'write')">Сохранить</vs-button>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import { DEVICE_TYPE } from "@/constants/deviceTypes";

export default {
  name:   "DevicesSettings",
  mixins: [notifyHttpError],
  data() {
    return {
      electricityTypes:       [],
      devicesSettings:        null,
      config:                 {},
      selectedApartmentsType: this.$store.getters['appUser/availableApartmentsTypes'][0].id,
    };
  },
  computed: {
    apartmentTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },

    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    getDeviceType( deviceTypeId ) {
      if (deviceTypeId === 'electricity') {
        return {
          icon:       "ElectricityIcon",
          icon_color: "warning",
          name:       this.electricityTypes.map(deviceType => deviceType.name).join('/'),
        };
      }
      return this.$store.getters['common/devices/typeById'](deviceTypeId);
    },

    getSettings() {
      return this.$http.get('device_values_settings', {
        params: {
          buildings_id:    this.selectedHouseId,
          apartments_type: this.selectedApartmentsType,
        },
      }).then(( { data } ) => {
        const config = { ...data.parameters };

        for (let deviceId in config) {
          const parameter = config[deviceId];
          if (typeof parameter.display !== 'boolean') parameter.display = false;
        }

        // Группировка счетчиков с электричеством в 1 сроку
        let firstElectricityDevice = null;
        const electricityTypes = [];
        [
          DEVICE_TYPE.ELECTRICITY_1,
          DEVICE_TYPE.ELECTRICITY_2,
          DEVICE_TYPE.ELECTRICITY_3,
        ].forEach(deviceTypeId => {
          if (!config[deviceTypeId]) return;
          const deviceType = this.getDeviceType(deviceTypeId);
          if (!firstElectricityDevice) firstElectricityDevice = config[deviceTypeId];
          electricityTypes.push(deviceType);
          delete config[deviceTypeId];
        });
        if (firstElectricityDevice) {
          config.electricity = {
            ...firstElectricityDevice,
          };
        }

        this.electricityTypes = electricityTypes;
        this.config = config;
        this.devicesSettings = data;
      }, this.notifyHttpError);
    },

    saveSettings() {
      const parameters = { ...this.config };
      if (parameters.electricity) {
        this.electricityTypes.forEach(deviceType => {
          parameters[deviceType.id] = parameters.electricity;
        });
        delete parameters.electricity;
      }

      this.$http.put('device_values_settings/' + this.devicesSettings.id, {
        ...this.devicesSettings,
        parameters,
      }).then(() => {
        this.$vs.notify({ color: 'success', title: 'Настройки изменены', text: 'Данные успешно сохранены' });
        this.getSettings();
      }, this.notifyHttpError);
    },
  },
  mounted() {
    this.getSettings();
  },
  watch: {
    selectedApartmentsType() {
      this.getSettings();
    },
    selectedHouseId() {
      this.selectedApartmentsType = this.$store.getters['appUser/availableApartmentsTypes'][0].id;
      this.getSettings();
    },
  },
};
</script>

<style lang="scss" scoped>

.device-icon {
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
}

.settings-table-wrapper {
  max-width: 100%;
  overflow-x: auto;
}

.settings-table {
  margin: 0 auto;

  td {
    padding: 6px 10px;
  }
}

.filterType {
  width: 160px;
}
</style>
